export const USER_ROLES = ["ADMIN", "AGENT", "PROPERTY_MANAGER", "WORKER", "SUPERVISOR", "CODEX"];

export const USER_ROLE_BADGE_VARIANTS = {
    ADMIN: "danger",
    AGENT: "primary",
    PROPERTY_MANAGER: "info",
    WORKER: "success",
    SUPERVISOR: "warning",
    CODEX: "dark",
};
